import gql from 'graphql-tag'
export default gql`mutation updatePlantMutation($plantId: Int!, $plant: BasePlant!) {
  updatePlant(plantId: $plantId, plant: $plant) {
    name
    id
  }
}`